import { Controller } from "@hotwired/stimulus";

// Lecteur de la vidéo explicative, repris de sxnlabs.com
// (frontend/javascript/controllers/video_events_controller.js du dépôt Website).
// Un video_play et un video_complete par affichage de page, quel que soit le
// nombre de pauses ou de relectures. L'affiche ne dessine pas de bouton : avant
// la première lecture, les commandes natives restent masquées et un bouton
// rond est centré sur l'affiche. Sans JavaScript, les commandes restent
// visibles et la vidéo se lit quand même.
export default class extends Controller {
  static targets = ["video", "start"];

  connect() {
    if (!this.hasVideoTarget || !this.hasStartTarget || !this.videoTarget.paused) return;

    this.videoTarget.controls = false;
    this.startTarget.hidden = false;
  }

  start() {
    this.reveal();
    this.videoTarget.play();
  }

  play() {
    this.reveal();
    if (this.played) return;
    this.played = true;
    window.sa_event?.("video_play", { offer: "website" });
  }

  ended() {
    if (this.completed) return;
    this.completed = true;
    window.sa_event?.("video_complete", { offer: "website" });
  }

  reveal() {
    if (this.hasVideoTarget) this.videoTarget.controls = true;
    if (this.hasStartTarget) this.startTarget.hidden = true;
  }
}
